import { render, staticRenderFns } from "./PatientVisitManagementV2.vue?vue&type=template&id=139e0e9a&scoped=true"
import script from "./PatientVisitManagementV2.vue?vue&type=script&lang=js"
export * from "./PatientVisitManagementV2.vue?vue&type=script&lang=js"
import style0 from "./PatientVisitManagementV2.vue?vue&type=style&index=0&id=139e0e9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139e0e9a",
  null
  
)

export default component.exports